import { createSelector } from 'reselect'

const selectPassportData = (state) => state.passport

export const selectRoute = () => createSelector(
    selectPassportData,
    (Data) => { 
        return Data.routeInfo
    }
)

export const selectStepsItems = () => createSelector(
    selectPassportData,
    (Data) => { 
        return Data.items
    }
)

export const selectStepsId = () => createSelector(
    selectPassportData,
    (Data) => { 
        return Data.stepId
    }
)

export const selectStepsEdges = () => createSelector(
    selectPassportData,
    (Data) => { 
        const edges = []
        Data.relations.map((line) => {

            if (line.start[0] && line.end[0]) edges.push({props: {id:`${line.start[0]}${line.end[0]}`, start:line.start[0].toString(), end:line.end[0].toString()}})
        })

        return edges
    }
)

export const selectStepsFetchLoading = () => createSelector(
    selectPassportData,
    (Data) => Data.loading
)

export const selectStepsFetchUrl = () => createSelector(
    selectPassportData,
    (Data) => Data.url
)


export const selectStepsFetchErrors = () => createSelector(
    selectPassportData,
    (Data) => {
        const validations = {}
        const errorText = ""

        if (Data.errors) {
            if (Data.errors !== null 
                && typeof (Data.errors.non_field_errors) !== 'undefined'
                && typeof (Data.errors.non_field_errors) !== 'string'
            ) {
                let html = ''

                Data.errors.non_field_errors.map((val) => {
                    html += val.message
                })

                errorText = html
            } else if (Object.keys(Data.errors).length > 0) {
                for (const k in Data.errors) {
                    validations[k] = Data.errors[k][0]
                }
            }
        }

        return {validations, errorText}
    }
)


export const selectAddStepLoading = () => createSelector(
    selectPassportData,
    (Data) => Data.adding.loading
)

export const selectAddStepIsDone = () => createSelector(
    selectPassportData,
    (Data) => Data.adding.isDone
)

export const selectAddStepErrors = () => createSelector(
    selectPassportData,
    (Data) => {
        const validations = {}
        const errorText = ""


        if (Data.adding.errors) {
            if (Data.adding.errors !== null 
                && typeof (Data.adding.errors.non_field_errors) !== 'undefined'
                && typeof (Data.adding.errors.non_field_errors) !== 'string'
            ) {
                let html = ''

                Data.adding.errors.non_field_errors.map((val) => {
                    html += val.message
                })

                errorText = html
            } else if (Object.keys(Data.adding.errors).length > 0) {
                for (const k in Data.adding.errors) {
                    validations[k] = Data.adding.errors[k][0]
                }
            }
        }

        return {validations, errorText}
    }
)


export const selectUpdateStepLoading = (id) => createSelector(
    selectPassportData,
    (Data) => (Data.updating[id] && Data.updating[id].loading ? Data.updating[id].loading : false)
)

export const selectUpdateStepIsDone = (id) => createSelector(
    selectPassportData,
    (Data) => (Data.updating[id] && Data.updating[id].isDone ? Data.updating[id].isDone : false)
)

export const selectUpdateStepErrors = (id) => createSelector(
    selectPassportData,
    (Data) => {
        const validations = {}
        const errorText = ""

        if (Data.updating[id] && Data.updating[id].errors) {
            if (Data.updating[id].errors !== null 
                && typeof (Data.updating[id].errors.non_field_errors) !== 'undefined'
                && typeof (Data.updating[id].errors.non_field_errors) !== 'string'
            ) {
                let html = ''

                Data.updating[id].errors.non_field_errors.map((val) => {
                    html += val.message
                })

                errorText = html
            } else if (Object.keys(Data.updating[id].errors).length > 0) {
                for (const k in Data.errors) {
                    validations[k] = Data.updating[id].errors[k][0]
                }
            }
        }

        return {validations, errorText}
    }
)


export const selectPublishLoading = (identifier) => createSelector(
    selectPassportData,
    (Data) => (Data.publish[identifier] && Data.publish[identifier].loading ? Data.publish[identifier].loading : false)
)


export const selectPublishErrors = (identifier) => createSelector(
    selectPassportData,
    (Data) => {
        const validations = {}
        const errorText = ""

        if (Data.publish[identifier] && Data.publish[identifier].errors) {
            if (Data.publish[identifier].errors !== null 
                && typeof (Data.publish[identifier].errors.non_field_errors) !== 'undefined'
                && typeof (Data.publish[identifier].errors.non_field_errors) !== 'string'
            ) {
                let html = ''

                Data.publish[identifier].errors.non_field_errors.map((val) => {
                    html += val.message
                })

                errorText = html
            } else if (Object.keys(Data.publish[identifier].errors).length > 0) {
                for (const k in Data.errors) {
                    validations[k] = Data.publish[identifier].errors[k][0]
                }
            }
        }

        return {validations, errorText}
    }
)

export const selectRequestStepDataLoading = (stepId) => createSelector(
    selectPassportData,
    (Data) => (Data.request[stepId] && Data.request[stepId].loading ? Data.request[stepId].loading : false)
)


export const selectRequestStepDataErrors = (stepId) => createSelector(
    selectPassportData,
    (Data) => {
        const validations = {}
        const errorText = ""

        if (Data.request[stepId] && Data.request[stepId].errors) {
            if (Data.publish[stepId].errors !== null 
                && typeof (Data.request[stepId].errors.non_field_errors) !== 'undefined'
                && typeof (Data.request[stepId].errors.non_field_errors) !== 'string'
            ) {
                let html = ''

                Data.request[stepId].errors.non_field_errors.map((val) => {
                    html += val.message
                })

                errorText = html
            } else if (Object.keys(Data.request[stepId].errors).length > 0) {
                for (const k in Data.errors) {
                    validations[k] = Data.request[stepId].errors[k][0]
                }
            }
        }

        return {validations, errorText}
    }
)

export const selectPartnerRoutePanZoom = () => createSelector(
  selectPassportData,
  (Data) => { 
      return Data.routeInfo.passportRoutePanZoom
  }
)


export const selectApplyForCertificationLoading = (stepId) => createSelector(
    selectPassportData,
    (Data) => (Data.apply[stepId] && Data.apply[stepId].loading ? Data.apply[stepId].loading : false)
)


export const selectApplyForCertificationErrors = (stepId) => createSelector(
    selectPassportData,
    (Data) => {
        const validations = {}
        const errorText = ""

        if (Data.apply[stepId] && Data.apply[stepId].errors) {
            if (Data.apply[stepId].errors !== null 
                && typeof (Data.apply[stepId].errors.non_field_errors) !== 'undefined'
                && typeof (Data.apply[stepId].errors.non_field_errors) !== 'string'
            ) {
                let html = ''

                Data.apply[stepId].errors.non_field_errors.map((val) => {
                    html += val.message
                })

                errorText = html
            } else if (Object.keys(Data.apply[stepId].errors).length > 0) {
                for (const k in Data.errors) {
                    validations[k] = Data.apply[stepId].errors[k][0]
                }
            }
        }

        return {validations, errorText}
    }
)


export const selectDoCertifyLoading = (stepId) => createSelector(
    selectPassportData,
    (Data) => (Data.certify[stepId] && Data.certify[stepId].loading ? Data.certify[stepId].loading : false)
)

export const selectDoCertifyIsDone = (stepId) => createSelector(
    selectPassportData,
    (Data) => (Data.certify[stepId] && Data.certify[stepId].isDone ? Data.certify[stepId].isDone : false)
)


export const selectDoCertifyErrors = (stepId) => createSelector(
    selectPassportData,
    (Data) => {
        const validations = {}
        const errorText = ""

        if (Data.certify[stepId] && Data.certify[stepId].errors) {
            if (Data.certify[stepId].errors !== null 
                && typeof (Data.certify[stepId].errors.non_field_errors) !== 'undefined'
                && typeof (Data.certify[stepId].errors.non_field_errors) !== 'string'
            ) {
                let html = ''

                Data.certify[stepId].errors.non_field_errors.map((val) => {
                    html += val.message
                })

                errorText = html
            } else if (Object.keys(Data.certify[stepId].errors).length > 0) {
                for (const k in Data.errors) {
                    validations[k] = Data.certify[stepId].errors[k][0]
                }
            }
        }

        return {validations, errorText}
    }
)


export const selectReceiveAssetLoading = (stepId) => createSelector(
    selectPassportData,
    (Data) => (Data.receive[stepId] && Data.receive[stepId].loading ? Data.receive[stepId].loading : false)
)

export const selectReceiveAssetIsDone = (stepId) => createSelector(
    selectPassportData,
    (Data) => (Data.receive[stepId] && Data.receive[stepId].isDone ? Data.receive[stepId].isDone : false)
)


export const selectReceiveAssetErrors = (stepId) => createSelector(
    selectPassportData,
    (Data) => {
        const validations = {}
        const errorText = ""

        if (Data.receive[stepId] && Data.receive[stepId].errors) {
            if (Data.receive[stepId].errors !== null 
                && typeof (Data.receive[stepId].errors.non_field_errors) !== 'undefined'
                && typeof (Data.receive[stepId].errors.non_field_errors) !== 'string'
            ) {
                let html = ''

                Data.receive[stepId].errors.non_field_errors.map((val) => {
                    html += val.message
                })

                errorText = html
            } else if (Object.keys(Data.receive[stepId].errors).length > 0) {
                for (const k in Data.errors) {
                    validations[k] = Data.receive[stepId].errors[k][0]
                }
            }
        }

        return {validations, errorText}
    }
)